"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Utils {
    static getItemsFromCollection(collection) {
        return (!collection || !collection._embedded || !collection._embedded.items) ? [] : collection._embedded.items;
    }
    static getOdataNext(response) {
        if (!response || !response._links || !response._links.next) {
            return undefined;
        }
        else {
            return {
                $Skip: Utils.getIntParam('skip', response._links.next),
                $SkipToken: Utils.getParam('skipToken', response._links.next),
                $Top: Utils.getIntParam('top', response._links.next),
                $Filter: Utils.getParam('filter', response._links.next),
                $Search: Utils.getParam('search', response._links.next),
                $Expand: Utils.getParam('expand', response._links.next),
                $Orderby: Utils.getParam('orderby', response._links.next)
            };
        }
    }
    static toArray(item) {
        return !item ? [] : item instanceof Array ? item : [item];
    }
    static timeout(timeoutMilliseconds, promise) {
        if (timeoutMilliseconds <= 0) {
            return promise;
        }
        else {
            let timeout;
            return Promise.race([promise, new Promise((_resolve, reject) => timeout = setTimeout(() => reject(new TimeoutError()), timeoutMilliseconds)),
            ]).then(_result => {
                clearTimeout(timeout);
                return promise;
            }).catch(error => {
                clearTimeout(timeout);
                throw error;
            });
        }
    }
    static isBlank(value) {
        return value == null || (typeof value === 'string' && value.trim().length === 0);
    }
    static getParam(name, selfLink) {
        const match = new RegExp(`\\$${name}=([^&]+)&?`).exec(selfLink);
        if (!match) {
            return undefined;
        }
        else {
            return match[1];
        }
    }
    static getIntParam(name, link) {
        const value = this.getParam(name, link);
        return !value ? undefined : parseInt(value);
    }
    static getGuid() {
        //Note (JQ):  sourced from https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
            const randomBits = Math.random() * 16 | 0;
            const value = character == 'x' ? randomBits : (randomBits & 0x3 | 0x8);
            return value.toString(16);
        });
    }
}
exports.Utils = Utils;
/**
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, message) {
        super(message);
        this.field = field;
        this.name = 'RequiredError';
    }
}
exports.RequiredError = RequiredError;
/**
 * Error thrown when a function takes too long to complete.
 *
 * @export
 * @class TimeoutError
 * @extends {Error}
 */
class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = 'TimeoutError';
    }
}
exports.TimeoutError = TimeoutError;
